module.exports = __webpack_public_path__ + "img/laboratorio_16-9_640.0976fb08.jpg";